<template>
  <div
    class="w-100 bg-white rounded-4 box-shadow-light-aff cursor-pointer"
    :class="{
      'border-2-green': isActive,
      'border-form': !isActive,
      'p-4': showDetail,
      'px-3 pt-2 pb-3 py-md-3': !showDetail,
    }">
    <div
      @click="selectPromotion()"
      v-if="promotion.show_discount_value"
      class="w-100 d-flex align-items-center pb-3 border-b-form-dashed-2 position-relative">
      <img
        src="../../../assets/img/icon/coupon.png"
        :height="$is_mobile_view ? '55' : '70'" />
      <div class="pl-2 pl-md-3 text-center">
        <h1 class="font-poppins-bold text-green mb-0 discount-amount">
          {{ promotion.formula_text }}
        </h1>
        <p
          class="text-color-normal mb-0"
          :class="$is_mobile_view ? 'sub-heading-1-2' : 'heading-6-1'">
          Discount
        </p>
      </div>
      <img
        v-if="showDetail"
        @click="closeDetail"
        src="../../../assets/img/icon/close.png"
        height="20"
        class="position-absolute cursor-pointer"
        style="top: 8px; right: 8px" />
    </div>
    <div @click="selectPromotion()" class="w-100 pt-3">
      <p
        class="mb-1"
        :class="{
          'sub-heading-1-2': showDetail,
          'body-1-2 text-truncate': !showDetail,
        }">
        {{ promotion.name }}
      </p>
      <template v-if="!showDetail">
        <div
          class="w-100"
          :style="{ height: $is_mobile_view ? '21px' : '42px' }">
          <p
            class="body-2-2-1 mb-0"
            :class="$is_mobile_view ? 'text-truncate' : 'text-truncate-2'"
            v-if="$isNotEmptyV2(promotion.description)">
            {{ promotion.description }}
          </p>
        </div>
      </template>
      <template v-else>
        <p class="body-2-2 mb-0" v-if="$isNotEmptyV2(promotion.description)">
          {{ promotion.description }}
        </p>
      </template>
      <div
        v-if="showDetail && promotion.rule_list.length > 0"
        class="w-100 rounded-4 p-3 bg-light-desktop mt-3 border-form">
        <ul class="pl-3">
          <li v-for="rule in promotion.rule_list">
            <p class="body-2-2-1 mb-0">{{ rule }}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="pt-3">
      <button
        v-if="isActive"
        class="g-btn w-100 px-0 g-btn-primary-outline rounded"
        :class="$is_mobile_view ? 'g-btn-sm' : 'g-btn-md'"
        @click="cancelPromotion()">
        Cancel Discount
      </button>
      <button
        v-else
        class="g-btn w-100 px-0 g-btn-primary rounded"
        :class="$is_mobile_view ? 'g-btn-sm' : 'g-btn-md'"
        @click="applyPromotion()">
        Apply Discount
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  props: ['promotion', 'promotionIndex', 'showDetail'],
  computed: {
    ...mapGetters(['getSelectedPromotion']),
    isActive() {
      if (this.$isEmpty(this.getSelectedPromotion)) return false;

      return this.getSelectedPromotion.id === this.promotion.id;
    },
  },
  methods: {
    ...mapMutations(['resetSelectedPromotion']),
    applyPromotion() {
      const index = this.showDetail ? -2 : this.promotionIndex;
      this.$emit('apply', index);
    },
    selectPromotion() {
      if (!this.showDetail) this.$emit('select', this.promotionIndex);
    },
    closeDetail() {
      this.$emit('closeDetail');
    },
    cancelPromotion() {
      this.resetSelectedPromotion();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/PromotionCard.vue